import { useState, useRef } from "react";
import { useTranslation } from "react-i18next";

import api from "@helpers/api";

import CustomModal from "@components/CustomModal";

import {Input} from "@fragments";

export default function RefundRequestModal({ modalRef }) {
  const { t } = useTranslation("member");
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const REF_config = useRef({});
  const REF_callback = useRef();

  modalRef.current = {
    open(preFill, callback) {
      console.log("Ref", preFill);
      REF_config.current = { ...preFill };
      REF_callback.current = callback;
      setOpen(true);
    },
  };

  async function handleSubmit() {
    try {
      setLoading(true);

      const { data } = await api.post("payments/refund", {
        id: REF_config.current.id,
        amount: REF_config.current.amount,
        charge: REF_config.current.provider.charge,
      });

      if (data) {
        await REF_callback.current(data);
        setOpen(false);
      }
    } catch (e) {
      console.log(e);
    }

    setLoading(false);
  }

  return (
    <CustomModal
      maxWidth={320}
      bottomButtonSumbitText={t("refundModal.submit")}
      bottomButtonCancelText={t("common:actions.cancel")}
      loading={loading}
      title={t("refundModal.title")}
      handleSubmit={handleSubmit}
      open={open}
      handleClose={() => setOpen(false)}
      bodyComponent={
        open ? (
          <div className="px-4 py-1">
            <Input
              className="mt-4"
              autoFocus={true}
              value={REF_config.current.amount}
              onInput={(v) => {
                REF_config.current.amount = v;
              }}
              label={t("refundModal.amountLabel")}
              type="money"
            />
          </div>
        ) : null
      }
    />
  );
}
